import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    events: [],
    loading: false
};

const route = "modules/driverPerformance/views/events/modals/eventInfo/redux/slice";

export const getEvents = createAsyncThunk("driverPerformance/eventTab/getEvent", async (payload, { rejectWithValue }) => {
    try {
        const response = await clientQuery(
            `
                query searchEvents ($conditions: [EventSearchInput], $sort: [EventSortInput], $limit: Int, $offset: Int) {
                    data: searchEvents (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                        items {
                            id
                            eventName
                            diagnostic
                            color
                            type
                            category
                        }
                        total
                    }
                }
            `,
            {
                conditions: [
                    {
                        fields: "type",
                        terms: ["risk"],
                        exact: true,
                    }
                ],
                sort: [
                    {
                        field: "eventName",
                        order: "ASC",
                    },
                ],
                limit: 1000,
                offset: 0,
            },
            endpoints.GRAPHQL_GENERAL_V2
        );

        return response?.data?.items || [];
    } catch (exc) {
        ExceptionManager(exc, route, "getEvent");
        return rejectWithValue(exc);
    }
}
);

//Slice
const driverPerformanceEventsTabEventInfoRedux = createSlice({
    name: "driverPerformance/eventInfo",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //getEvents
        builder.addCase(getEvents.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getEvents.fulfilled, (state, action) => {
            state.loading = false;
            state.events = action.payload
        });
        builder.addCase(getEvents.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = driverPerformanceEventsTabEventInfoRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
